import React, { useEffect } from "react";

// ui components
import "react-datepicker/dist/react-datepicker.css";

import styled from "styled-components";
import { RootState } from "../../store/rootReducer";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { StatusKerjasama } from "../../interfaces/StatusKerjasama";
import { getStatusKerjasamaAsync, selectStatusKerjasama } from "../../reducers/statusKerjasama/statusKerjasama.actions";
import { getStatusLabel } from "../../store/helpers";
import { PermissionMenuName } from "../../interfaces/UserRole";
// @ts-ignore
import { MUIDataTableMeta } from "mui-datatables";
import Datatables from "../../layouts/Datatables";
import { Tooltip } from '@mui/material';
import Zoom from '@mui/material/Zoom';

export const StatusKerjasamaListPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const isLoading = useSelector((state: RootState) => state.statusKerjasama.isLoading);
  const errorMessage = useSelector((state: RootState) => state.statusKerjasama.errorMessage);
  const listStatusKerjasama = useSelector((state: RootState) => state.statusKerjasama.listStatusKerjasama);
  const role = useSelector((state: RootState) => state.authorization.systemAccess[PermissionMenuName.masterData].ACCESS);

  useEffect(() => {
    refresh();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const createStatusKerjasama = () => {
    dispatch(selectStatusKerjasama(null));
    history.push(`/status-kerjasama/create`);
  }

  const editStatusKerjasama = (statusKerjasama: StatusKerjasama) => {
    dispatch(selectStatusKerjasama(statusKerjasama));
    history.push(`/status-kerjasama/${statusKerjasama.STATUS_ID}`);
  }

  const refresh = () => {
    if (isLoading) return;
    dispatch(getStatusKerjasamaAsync.request({}));
  }

  const renderStatusKerjasama = () => {
    if (errorMessage) {
      return (
        // <tr>
        //   <td colSpan={4} style={{textAlign: 'center'}}>
        //   Terdapat kesalahan dalam memuat data: <b>{errorMessage}</b><br/><button className="btn btn-primary btn-xs" onClick={refresh}>Coba Perbaharui Halaman</button>
        //   </td>
        // </tr>

        <div style={{textAlign: 'center'}}>
          Terdapat kesalahan dalam memuat data: <b>{errorMessage}</b><br/><button className="btn btn-primary btn-xs" onClick={refresh}>Coba Perbaharui Halaman</button>
        </div>
      )
    }

    if (isLoading) {
      return (
        // <tr>
        //   <td colSpan={3} style={{textAlign: 'center'}}>
        //     Sedang memuat data &nbsp; <i className="fa fa-refresh fa-spin"></i>
        //   </td>
        // </tr>

        <div style={{textAlign: 'center'}}>
          Sedang memuat data &nbsp; <i className="fa fa-refresh fa-spin"></i>
        </div>
      );
    }

    if (listStatusKerjasama.length === 0) {
      return (
        // <tr>
        //   <td colSpan={4} style={{textAlign: 'center'}}>
        //     Data tidak ditemukan: &nbsp; <button className="btn btn-primary btn-xs" onClick={refresh}>Coba Perbaharui Halaman</button>
        //   </td>
        // </tr>

        <div style={{textAlign: 'center'}}>
          Data tidak ditemukan: &nbsp; <button className="btn btn-primary btn-xs" onClick={refresh}>Coba Perbaharui Halaman</button>
        </div>
      );
    }
    
    // return listStatusKerjasama.map((statusKerjasama, index) => {
    //   return (
    //     <tr key={statusKerjasama.STATUS_ID}>
    //       <td>{index + 1}</td>
    //       <td>{statusKerjasama.STATUS_NAME}</td>
    //       <td>{getStatusLabel(statusKerjasama.STATUS)}</td>
    //       <th>
    //         <button className="btn btn-primary btn-xs" onClick={() => editStatusKerjasama(statusKerjasama)}>
    //           <i className="fa fa-edit" aria-hidden="true"></i>
    //         </button>
    //       </th>
    //     </tr>
    //   );
    // })

    const items = listStatusKerjasama.map((item, index) => ({
      NO: index + 1,
      id: item.STATUS_ID,
      STATUS_DESC: getStatusLabel(item.STATUS),
      ...item,
    }));

    const getHeaderProps = (width: string, padding: string) => {
      return {
        style: {
          width: width,
          maxWidth: width,
          padding: padding
        },
      };
    };

    const getCellProps = (width: string, padding: string, align: string) => {
      return {
        style: {
          width: width,
          maxWidth: width,
          padding: padding,
          fontSize: '12px',
          textAlign: `${align}`
        },
      };
    };

    const actionRenderer = (value: any, tableMeta: MUIDataTableMeta) => {
      const row = items[tableMeta.rowIndex];

      return (
        <div style={{display: 'flex'}}>
          <Tooltip title="Ubah"
            slots={{
              transition: Zoom,
            }} 
            componentsProps={{
              tooltip: {
                sx: {
                  fontSize: '11px'
                },
              },
            }}>
            <button className="btn btn-primary btn-xs" onClick={() => editStatusKerjasama(row)}>
              <i className="fa fa-edit" aria-hidden="true"></i>
            </button>
          </Tooltip>
        </div>
      );
    }

    const columns = [
      {
        name: "NO",
        label: "No",
        options: {
          filter: false,
          sort: true,
          setCellHeaderProps: () => getHeaderProps('50px', '5px 0 5px 0'),
          setCellProps: () => getCellProps('50px', '5px 0 5px 10px', 'left')
        },
      },
      {
        name: "STATUS_NAME",
        label: "Nama",
        options: {
          filter: true,
          sort: true,
          setCellHeaderProps: () => getHeaderProps('70%', '5px 0 5px 0'),
          setCellProps: () => getCellProps('70%', '5px 0 5px 10px', 'left')
        }
      },
      {
        name: "STATUS_DESC",
        label: "Status",
        options: {
          filter: true,
          sort: true,
          setCellHeaderProps: () => getHeaderProps('20%', '5px 0 5px 0'),
          setCellProps: () => getCellProps('20%', '5px 0 5px 10px', 'left')
        }
      },
      { 
        name: "actions",
        label: " ",
        options: {
          filter: false,
          sort: false,
          download: false,
          setCellHeaderProps: () => getHeaderProps('9%', '5px 0 5px 0'),
          setCellProps: () => getCellProps('9%', '5px 0 5px 10px', 'left'),
          customBodyRender: actionRenderer
        },
      }
    ];
    
    return (
      <Datatables data={items} col={columns} title={'Daftar Status Kerjasama'} />
    )
  }

  return (
    <StatusKerjasamaListPageWrapper>
      <section className="content">
        <div className="row">
          <div className="col-lg-6">
            <div className="box">
              <div className="box-header" style={{marginTop: '4px'}}>
                <h3 className="box-title">Daftar Status Kerjasama</h3>

                <div className="box-tools">
                  <button
                    disabled={!role.create}
                    className="btn btn-primary"
                    onClick={createStatusKerjasama}
                  >
                    Tambah Baru
                  </button>
                </div>
              </div>
              {/* <div className="box-body table-responsive no-padding">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Nama</th>
                      <th>Status</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    { renderStatusKerjasama() }
                  </tbody>
                </table>
              </div> */}

              <div style={{padding: '0 10px 10px 10px'}}>
                { renderStatusKerjasama() }
              </div>
            </div>
          </div>
        </div>
      </section>
    </StatusKerjasamaListPageWrapper>
  );
};

const StatusKerjasamaListPageWrapper = styled.div``;
